export enum SupportType {
  ADMINISTRATIVE = "ADMINISTRATIVE",
  FINANCIAL = "FINANCIAL",
  PORTAL = "PORTAL",
  COMMERCIAL = "COMMERCIAL",
  TECHNICAL = "TECHNICAL",
  CONTRACT_CANCELLATION = "CONTRACT_CANCELLATION",
}

export const typesSupportOccorence = {
  TECHNICAL_SUPPORT: "TAS - Suporte Técnico",
  VOLKSTOTAL: "Suporte Volkstotal",
};

export const typesOcorrenceStatus = {
  OPEN: "Pendente de análise",
  IN_ANALYSIS: "Em análise VWCO",
  ANSWERED: "Respondido ao Dealer",
  FINISHED: "Finalizado",
};

export const typeStatusOccurence = [
  { label: "Pendente de análise", id: "OPEN" },
  { label: "Em análise VWCO", id: "IN_ANALYSIS" },
  { label: "Respondido ao dealer", id: "ANSWERED" },
  { label: "Finalizados", id: "FINISHED" },
];

export const typeSubjectOccorence = {
  ADMINISTRATIVE: "Administrativo",
  FINANCIAL: "Financeiro",
  PORTAL: "Portal VolksTotal",
  COMMERCIAL: "Comercial",
  TECHNICAL: "Técnico",
  CONTRACT_CANCELLATION: "Cancelamento de contrato",
  CABIN: "01. Cabine (Acabamentos, Bancos, climatizador, Geladeira e A/C)",
  GEARBOX: "02. Caixa de mudanças / mecanismo de seleção e engate",
  CHASSIS: "03. Chassi (Componentes ligados)",
  SUPPORT_AXLE: "04. Eixo de apoio (truck)",
  FRONT_AXLE: "05. Eixo dianteiro / 2º eixo direcional",
  CLUTCH: "06. Embreagem (incluindo sistema de acionamento)",
  ENGINE: "07. Motor (veículo diesel)",
  E_DELIVERY: "08. E-Delivery",
  WHEEL: "09. Roda (retentor / cubo / rolamento)",
  STEERING_SYSTEM: "10. Sistema de direção",
  EXHAUST_SYSTEM_AND_AFTER_TREATMENT:
    "11. Sistema de exaustão e pós tratamento",
  BRAKE_SYSTEM: "12. Sistema de freios e circuito pneumático",
  ELECTRICAL_SYSTEM: "13. Sistema elétrico (veículo diesel)",
  DRIVE_AXLE: "14. Eixo trativo (diferencial)",
  SUSPENSION: "15. Suspensão",
  POWER_TAKEOFF: "16. Tomada de força",
  TRANSMISSION: "17. Transmissão (cruzeta, semi-árvores, cardan)",
  SOFTWARE_DIESEL_VEHICLE: "18. Software (Veículo Diesel)",
  ENGINE_REPLACEMENT_REQUEST: "19. Solicitação de troca do motor",
  SOFTWARE_IDLE_AUTO_SHUTDOWN:
    "20. Software - AT 011-26-Desligamento automático por tempo em marcha lenta",
  TAS_DIAGNOSIS_TOOLS: "TAS - 2. Ferramentas de diagnose",
};

export const subTopicSupport = {
  MANUAL_CONTRACT_REGISTRATION: "Cadastro manual de contrato / aditamento",
  INVOICE_REQUEST: "Solicitação de boletos / notas fiscais",
  REGISTRATION_CHANGE_REQUEST: "Solicitação de alteração de cadastro",
  CONTRACT_DUE_DATE_CHANGE: "Alteração de data de vencimento do contrato",
  CONTRACT_BLOCKED_AUTHORIZATION:
    "Contrato bloqueado / autorização de atendimento",
  INVOICE_CANCELLATION: "Cancelamento de nota fiscal",
  BILLING_QUESTIONS: "Dúvida referente a cobrança (valores / regras)",
  CONTRACT_RENEGOTIATION: "Renegociação de contrato",
  CONTRACT_STATUS_CONSULTATION: "Consulta Status do contrato",
  BOLETO_AMOUNT_UPDATE:
    "Atualização do valor de cobrança do boleto (pós vencimento)",
  KM_HOUR_MEASUREMENT: "Aferição de km / hora",
  VOLKS_TOTAL_PORTAL_ACCESS: "Acesso ao portal Volks|Total",
  GENERAL_QUESTIONS: "Dúvidas gerais",
  COMMERCIAL: "Comercial",
  REQUEST: "Solicitação",
  CONTRACT_EXTENSION_RENEWAL: "aditamento/renovação",
  REPAIR_AUTHORIZATION: "Autorização de reparo",
  PARTS_COVERAGE: "Cobertura de peças",
  TECHNICAL_QUESTION: "Dúvida técnica",
  CHASSIS_REPAIR_HISTORY: "Histórico do chassi / reparo",
  LATE_REVIEW_TOLERANCE: "Revisão fora do prazo (tolerância)",
  COMPLEMENTARY_OPERATIONS: "Operações complementares",
  REVIEW_CHECKLIST_ITEMS: "Itens do checklist de revisão",
  REGISTRATION_AND_CONTRACT_VERIFICATION:
    "Verificação de cadastro / ativação de contratos / aditamento",
  PROMOTIONAL_PLAN_ACTIVATION: "Ativação de Plano Promocional",
  CONTRACT_STATUS_INQUIRY: "Consulta de status do contrato",
  BLOCKED_CONTRACT_SERVICE_AUTHORIZATION:
    "Contrato bloqueado - autorização de atendimento",
  INVOICE_DUE_DATE_CHANGE:
    "Alteração de data de vencimento do boleto",
  OPEN_CHARGES_RENEGOTIATION:
    "Renegociação de cobranças em aberto",
  INVOICE_AND_NF_ISSUANCE: "Emissão de boleto / NF",
  PARTS_COVERAGE_QUESTION:
    "Dúvida sobre cobertura de peças",
  REVISION_CHECKLIST_QUESTION:
    "Dúvidas sobre checklist de revisão",
  MAINTENANCE_AND_COMPLEMENTARY_SERVICES_HISTORY:
    "Histórico de manutenção / serviços complementares",
  TRUCKER_ASSIST_REGISTRATION: "Cadastro Trucker Assist",
};

export const optionsAdministrative = [
  {
    id: "TRUCKER_ASSIST_REGISTRATION",
    label: "Cadastro Trucker Assist",
  },
  {
    id: "REGISTRATION_AND_CONTRACT_VERIFICATION",
    label: "Verificação de cadastro / ativação de contratos / aditamento",
  },
  {
    id: "PROMOTIONAL_PLAN_ACTIVATION",
    label: "Ativação de Plano Promocional",
  },
  {
    id: "CONTRACT_STATUS_INQUIRY",
    label: "Consulta de status do contrato",
  },
  {
    id: "BLOCKED_CONTRACT_SERVICE_AUTHORIZATION",
    label: "Contrato bloqueado - autorização de atendimento",
  },
  {
    id: "REGISTRATION_CHANGE_REQUEST",
    label: "Solicitação de alteração de cadastro",
  },
];

export const optionsFinancial = [
  {
    id: "INVOICE_DUE_DATE_CHANGE",
    label: "Alteração de data de vencimento do boleto",
  },
  {
    id: "BOLETO_AMOUNT_UPDATE",
    label: "Atualização do valor de cobrança do boleto (pós vencimento)",
  },
  {
    id: "INVOICE_CANCELLATION",
    label: "Cancelamento de nota fiscal",
  },
  {
    id: "BILLING_QUESTIONS",
    label: "Dúvida referente a cobrança (valores / regras)",
  },
  {
    id: "OPEN_CHARGES_RENEGOTIATION",
    label: "Renegociação de cobranças em aberto",
  },
  {
    id: "INVOICE_AND_NF_ISSUANCE",
    label: "Emissão de boleto / NF",
  },
];

export const optionsVolksTotalPortal = [
  {
    id: "KM_HOUR_MEASUREMENT",
    label: "Aferição de km / hora",
  },
  {
    id: "VOLKS_TOTAL_PORTAL_ACCESS",
    label: "Acesso ao portal VolksTotal",
  },
  {
    id: "GENERAL_QUESTIONS",
    label: "Dúvidas gerais",
  },
];

export const optionsTechnical = [
  {
    id: "REPAIR_AUTHORIZATION",
    label: "Autorização de reparo",
  },
  {
    id: "PARTS_COVERAGE_QUESTION",
    label: "Dúvida sobre cobertura de peças",
  },
  {
    id: "TECHNICAL_QUESTION",
    label: "Dúvida técnica",
  },
  {
    id: "REVISION_CHECKLIST_QUESTION",
    label: "Dúvidas sobre checklist de revisão",
  },
  {
    id: "MAINTENANCE_AND_COMPLEMENTARY_SERVICES_HISTORY",
    label: "Histórico de manutenção / serviços complementares",
  },
  {
    id: "LATE_REVIEW_TOLERANCE",
    label: "Revisão fora do prazo (tolerância)",
  },
];

export const supportSubjectOptions = [
  {
    id: "CABIN",
    label: "01. Cabine (Acabamentos, Bancos, climatizador, Geladeira e A/C)",
  },
  {
    id: "GEARBOX",
    label: "02. Caixa de mudanças / mecanismo de seleção e engate",
  },
  {
    id: "CHASSIS",
    label: "03. Chassi (Componentes ligados)",
  },
  {
    id: "SUPPORT_AXLE",
    label: "04. Eixo de apoio (truck)",
  },
  {
    id: "FRONT_AXLE",
    label: "05. Eixo dianteiro / 2º eixo direcional",
  },
  {
    id: "CLUTCH",
    label: "06. Embreagem (incluindo sistema de acionamento)",
  },
  {
    id: "ENGINE",
    label: "07. Motor (veículo diesel)",
  },
  {
    id: "E_DELIVERY",
    label: "08. E-Delivery",
  },
  {
    id: "WHEEL",
    label: "09. Roda (retentor / cubo / rolamento)",
  },
  {
    id: "STEERING_SYSTEM",
    label: "10. Sistema de direção",
  },
  {
    id: "EXHAUST_SYSTEM_AND_AFTER_TREATMENT",
    label: "11. Sistema de exaustão e pós tratamento",
  },
  {
    id: "BRAKE_SYSTEM",
    label: "12. Sistema de freios e circuito pneumático",
  },
  {
    id: "ELECTRICAL_SYSTEM",
    label: "13. Sistema elétrico (veículo diesel)",
  },
  {
    id: "DRIVE_AXLE",
    label: "14. Eixo trativo (diferencial)",
  },
  {
    id: "SUSPENSION",
    label: "15. Suspensão",
  },
  {
    id: "POWER_TAKEOFF",
    label: "16. Tomada de força",
  },
  {
    id: "TRANSMISSION",
    label: "17. Transmissão (cruzeta, semi-árvores, cardan)",
  },
  {
    id: "SOFTWARE_DIESEL_VEHICLE",
    label: "18. Software (Veículo Diesel)",
  },
  {
    id: "ENGINE_REPLACEMENT_REQUEST",
    label: "19. Solicitação de troca do motor",
  },
  {
    id: "SOFTWARE_IDLE_AUTO_SHUTDOWN",
    label:
      "20. Software - AT 011-26-Desligamento automático por tempo em marcha lenta",
  },
  {
    id: "TAS_DIAGNOSIS_TOOLS",
    label: "TAS - 2. Ferramentas de diagnose",
  },
];

export const supportStatusOptions = [
  { id: "ADMINISTRATIVE", label: "Administrativo" },
  { id: "FINANCIAL", label: "Financeiro" },
  { id: "PORTAL", label: "Portal VolksTotal" },
  // { id: "COMMERCIAL", label: "Comercial" },
  { id: "TECHNICAL", label: "Técnico" },
  { id: "CONTRACT_CANCELLATION", label: "Cancelamento de contrato" },
];

export const F2_FORM_SUBJECTS = [
  "GEARBOX",
  "CHASSIS",
  "SUPPORT_AXLE",
  "FRONT_AXLE",
  "CLUTCH",
  "ENGINE",
  "E_DELIVERY",
  "WHEEL",
  "STEERING_SYSTEM",
  "BRAKE_SYSTEM",
  "ELECTRICAL_SYSTEM",
  "DRIVE_AXLE",
  "SUSPENSION",
  "POWER_TAKEOFF",
  "TRANSMISSION",
];

export const INPUTS_NAME = {
  id: "id",
  tasOccurrence: "",
  tasOccurrenceNumber: "Número do contrato",
  supportType: "Tipo de suporte",
  responsible: "",
  assignedTo: "Atribuído á",
  assignedToId: "Atribuído á",
  chassis: "Chassis",
  licensePlate: "Placa",
  dn: "DN",
  dnResponsible: "Responsável pelo DN",
  phone: "Telefone",
  customer: "Empresa",
  createdBy: "Criado por",
  hourMeter: "Horímetro",
  odometer: "Hodômetro",
  entryDate: "Data de entrada",
  createdAt: "Data de criação",
  updatedAt: "Ultima atualização",
  statusUpdatedAt: "",
  subject: "Assunto",
  details: "Detalhes",
  partName: "Nome da peça causadora",
  aeg: "Nº AEG",
  customerComment: "Detalhe da solicitação ou Qual a reclamação do cliente?",
  diagnose: "Diagnóstico / causa da falha",
  repair: "Reparo necessário",
  analysisReason: "Motivo do envio para análise",
  contractNumber: "",
  vehicleQtd: "Quantidade de veículos",
  cancelReason: "Motivo do cancelamento",
  cancelComment: "Descrever a solicitação",
  status: "Etapa",
  timeInStatus: "Tempo na etapa",
  subtopic: "Tema",
  partOrComponentName: "Nome da Peça ou Componente",
  partNumber: "Nº da peça VW/MAN",
  problemDescription: "O que aconteceu?",
  diagnosticAndResults: "Relate procedimentos de diagnóstico e resultados",
  problemSteps: "É possível reproduzir? Informe o passo-a-passo.",
  failureFrequency: "Em qual frequência a falha ocorre?",
  comment: 'Editou um comentário'
};

export const ACTIONS_NAME = {
  'UPDATE': 'Campo alterado',
  'CREATE': 'Campo criado',
  'DELETE': 'Campo deletado'
}

export const GroupsMatriz = {
  '6cf126dd-8753-4b31-a2de-fc11f223e471': 'crc',
  'b0aaec78-6d1b-4778-b6db-49b1bfda21d8': 'Backoffice',
  '8c564d38-1d8f-4b27-8613-80cf6482f0f8': 'gestores-aprovadores' 
}

export const optionsGroupsMatriz = [
  {
      id: '6cf126dd-8753-4b31-a2de-fc11f223e471',
      label: 'crc',
  },
  {
      id: 'b0aaec78-6d1b-4778-b6db-49b1bfda21d8',
      label: 'backoffice',
  },
  {
      id: '8c564d38-1d8f-4b27-8613-80cf6482f0f8',
      label: 'gestores-aprovadores',
  },
];


export const fieldLabelsSubject = {
  responsible: 'Responsável',
  dn: 'Dn',
  chassis: 'Chassi do veículo',
  licensePlate: 'Placa do veículo',
  dnResponsible: 'Responsável pelo chamado no DN',
  phone: 'Tel para contato',
  customer: 'Nome do cliente',
  regionalId: 'Regional',
  hourMeter: 'Horímetro',
  odometer: 'Km',
  entryDate: 'Data de entrada do veículo',
  customerComment: 'Detalhe da solicitação ou Qual a reclamação do cliente?',
  partName: 'Nome da peça causadora',
  aeg: 'N° AEG',
  diagnose: 'Diagnóstico / causa da falha',
  repair: 'Reparo necessário',
  analysisReason: 'Motivo do envio para análise',
  contractNumber: 'Número do contrato',
  vehicleQtd: 'Quantidade de veículos',
  cancelReason: 'Motivo do cancelamento',
  cancelComment: 'Descrever a solicitação',
  partOrComponentName: 'Nome da Peça ou Componente',
  partNumber: 'N° da peça VW/MAN',
  problemDescription: 'O que aconteceu?',
  problemSteps: 'É possível reproduzir? Informe o passo-a-passo.',
  diagnosticAndResults: 'Relate procedimentos de diagnóstico e resultados',
  failureFrequency: 'Em qual frequência a falha ocorre?'
};

export const fieldOptionsSubject = [
  { field: 'responsible', required: false },
  { field: 'dn', required: false },
  { field: 'chassis', required: false },
  { field: 'licensePlate', required: false },
  { field: 'dnResponsible', required: false },
  { field: 'phone', required: false },
  { field: 'customer', required: false },
  { field: 'regionalId', required: false },
  { field: 'hourMeter', required: false },
  { field: 'odometer', required: false },
  { field: 'entryDate', required: false },
  { field: 'customerComment', required: false },
  { field: 'partName', required: false },
  { field: 'aeg', required: false },
  { field: 'diagnose', required: false },
  { field: 'repair', required: false },
  { field: 'analysisReason', required: false },
  { field: 'contractNumber', required: false },
  { field: 'vehicleQtd', required: false },
  { field: 'cancelReason', required: false },
  { field: 'cancelComment', required: false },
  { field: 'partOrComponentName', required: false },
  { field: 'partNumber', required: false },
  { field: 'problemDescription', required: false },
  { field: 'problemSteps', required: false },
  { field: 'diagnosticAndResults', required: false },
  { field: 'failureFrequency', required: false },
];

export const SupportAssignmentFilter = {
  ASSIGNED: 'Chamados com atribuição',
  UNASSIGNED: 'Chamados sem atribuição',
  ALL: 'Todos os chamados',
}

export const SupportAssignmentFilterOptions = [{
  id: 'ASSIGNED',
  label: SupportAssignmentFilter.ASSIGNED,
},{
  id: 'UNASSIGNED',
  label: SupportAssignmentFilter.UNASSIGNED,
},{
  id: 'all',
  label: SupportAssignmentFilter.ALL,
}]

export const ASSIGNMENT_STATIC_IDS = ['ASSIGNED', 'UNASSIGNED', 'all'] as const;

export const isStaticAssignmentFilter = (id: string) =>
  ASSIGNMENT_STATIC_IDS.includes(id as (typeof ASSIGNMENT_STATIC_IDS)[number]);

export const resolveAssignmentSelection = (selected: string[], previous: string[]): string[] => {
  if (!selected.length) return ['all'];

  const newlyAdded = selected.filter((id) => !previous.includes(id));
  const lastAdded = newlyAdded[newlyAdded.length - 1] ?? selected[selected.length - 1];

  if (lastAdded === 'all') return ['all'];

  if (isStaticAssignmentFilter(lastAdded)) {
    return [lastAdded];
  }

  return selected.filter((id) => !isStaticAssignmentFilter(id));
};

export const assignmentSelectionToParams = (selection: string[]) => {
  const userIds = selection.filter((id) => !isStaticAssignmentFilter(id));

  if (userIds.length) {
    return { assigned: '', assignedToId: userIds.join(',') };
  }

  const staticFilter = selection[0] || 'all';

  if (staticFilter === 'all') {
    return { assigned: '', assignedToId: '' };
  }

  return { assigned: staticFilter, assignedToId: '' };
};

export const assignmentParamsToSelection = (assigned: string, assignedToId: string): string[] => {
  if (assignedToId) return assignedToId.split(',');
  if (assigned) return [assigned];
  return ['all'];
};
